import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [

  {
    path: '',
    loadChildren: () => import('./createComplaint/createComplaint.module').then(m => m.CreateComplaintModule),

  },

  {
    path: 'createComplaintPublic',
    loadChildren: () => import('./createComplaint/createComplaint.module').then(m => m.CreateComplaintModule),

  },
  {
    path: 'followUp',
    loadChildren: () => import('./followUp/followUp.module').then(m => m.FollowUpModule),

  },
  {
    path: '**',
    loadChildren: () => import('./createComplaint/createComplaint.module').then(m => m.CreateComplaintModule),

  },






];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'corrected',
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
